/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Модель контакта пользователя.
   */
  app.UserContact = app.Model.extend({
    defaults: {
      contact_type_id: null,
      value: '',
      is_whatsapp: '',
      is_viber: '',
      is_telegram: ''
    },
    /**
     * Контакт с номером телефона.
     * @returns {boolean}
     */
    isPhone: function () {
      return this.get('contact_type_id') == app.CONTACT_TYPES.phone;
    },
    /**
     * Список приложений (messengers) привязанных к телефону.
     * @returns {Array}
     */
    phoneApps: function () {
      var apps = [];
      if (this.isPhone()) {
        this.get('is_whatsapp') && apps.push('WhatsApp');
        this.get('is_viber') && apps.push('Viber');
        this.get('is_telegram') && apps.push('Telegram');
      }

      return apps;
    },
    /**
     * Номер телефона в человекочитаемом формате.
     * @returns {String}
     */
    phoneHumanFormat: function () {
      return app.helpers.PhoneHelper.getFormatedPhoneNumber(this.get('value'));
    }
  });
})();

}.call(window));